import { ERROR_MODAL_OPEN, ERROR_MODAL_CLOSE } from '@redux/actions/types'

const initialState = {
  error: null,
  showErrorModal: false
}

const reducer = (state = initialState, action) => {
  const { error, type } = action

  if (error) {
    return {
      ...state,
      error
    }
  }

  switch (type) {
  case ERROR_MODAL_OPEN:
    return {
      ...state,
      error: action.payload,
      showErrorModal: true
    }
  case ERROR_MODAL_CLOSE:
    return {
      ...state,
      error: null,
      showErrorModal: false
    }
  default:
    return state
  }
}

export default reducer
